import { IHttpClient } from '@/core/services/http'
import { VerifyAccountDto } from '../types/dtos/verify-code.dto'

export function createVerifyAccountUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (credentials: VerifyAccountDto) {
    await httpClient
      .version('v1')
      .post('/website/buyer/verify-code', credentials)
  }
}
